import { InfositeController } from './infosite-controller';
import { SearchController } from './search-controller';
// the order of this array matters due to the way controller path pattern matching
// works in bernie v4 (react-router v6) and the way the paths are set on each respective controller
export const lodging = [SearchController, InfositeController];